<template>
    <el-container class="pc-view">
        <el-aside class="my-aside">
            <el-tree
                ref="catalogTree"
                :data="catalogData"
                node-key="id"
                :indent="24"
                highlight-current
                :default-expanded-keys="expandedList"
                @current-change="treeNodeClick"
            >
                <div
                    class="overlength-text"
                    slot-scope="{ data }"
                    :title="data.title"
                >
                    <i v-if="data.type === 'page'" class="el-icon-document" style="margin-left: 16px;"></i>
                    <span :style="{marginLeft: data.type === 'page' ? '0px' : '16px'}">
                        {{ data.title }}
                    </span>
                </div>
            </el-tree>
        </el-aside>

        <el-main style="overflow-x: hidden; background: white; margin-left: 8px;">
            <div class="content-title">{{ title }}</div>
            <div v-if="bodyType == 0" class="fr-view" style="width: 100%; height: calc(100% - 128px); overflow-y: auto;" v-html="body"></div>
            <iframe style="width: 100%; border: none; height: calc(100% - 128px);" v-else :src="body"></iframe>
        </el-main>
    </el-container>
</template>

<script>
export default {
    name: 'PcView',
    data() {
        return {
            currentPage: null,
            firstContentId: '',
            expandedList: [],
            catalogData:[
                {
                    id: 1,
                    label: '一级 1',
                    level: 0,
                    type: 'catalog',
                    children: [{
                        id: 4,
                        label: '二级 1-1',
                        level: 1,
                        type: 'catalog',
                        children: [{
                            id: 9,
                            label: '三级 1-1-1',
                            type: 'catalog',
                            level: 2,
                        }, {
                            id: 10,
                            label: '三级 1-1-2',
                            type: 'catalog',
                            level: 2,
                        }]
                    }]
                },
                {
                    id: 3,
                    label: '一级 3',
                    level: 1,
                    children: [
                        {
                            id: 8,
                            label: '二级 3-2',
                            level: 2,
                            children: [{
                                id: 11,
                                label: '三级 3-2-1',
                                level: 2,
                                type: 'catalog'
                            }, {
                                id: 12,
                                label: '三级 3-2-2',
                                level: 2,
                                type: 'content'
                            }, {
                                id: 13,
                                label: '三级 3-2-3',
                                level: 2,
                                type: 'content'
                            }
                        ]
                    }, {
                            id: 7,
                            label: '二级 3-1',
                            level: 2,
                            type: 'catalog',
                        }]
                 }, 
                {
                    id: 2,
                    label: '一级 2',
                    level: 1,
                    type: 'catalog',
                    children: [
                        {
                            id: 5,
                            label: '二级 2-1',
                            level: 2,
                            type: 'catalog',
                        }, {
                            id: 6,
                            label: '二级 2-2',
                            level: 2,
                            type: 'content',
                        }
                    ]
                }, {
                    id: 15,
                    label: '一级 4',
                    level: 1,
                    type: 'content'
            }],
            title: '',
            bodyType: 0,
            body: ''
        }
    },
    methods: {
        treeNodeClick(nodeData) {
            // 只有网页可以点击
            if (nodeData.type  !==  'page') {
                this.$refs.catalogTree.setCurrentKey(this.currentPage.id)
                return
            }
            // 选定当前的条目
            this.currentPage = nodeData
            this.getPageDetail()
        },
        getPageDetail() {
            this.$http({
                url: '/v1/content/itemById',
                method: 'get',
                params: {itemId: this.currentPage.id}
            }).then(res => {
                this.title = res.title
                this.bodyType = res.bodyType
                this.body = res.body
            }).catch(err => {
                console.info(err)
            })
        },
        getFirstContent(data) {
            if (data.length) {
                if (data[data.length - 1].type === 'page') {
                    // 说明有此级有文章
                    for (let i = 0; i < data.length; i++) {
                        if (data[i].type === 'page') {
                            this.firstContentId = data[i].id
                            break
                        }
                    }
                } else {
                    for (let i = 0; i < data.length; i++) {
                        if (this.firstContentId) {
                            break
                        } else if(data[i].children) {
                            this.getFirstContent(data[i].children)
                        }
                    }
                }
            }
        }
    },
    mounted() {
        this.$http({
            url: '/v1/content/catalog',
            method: 'get',
            params: {contentId: this.$route.query.contentId}
        }).then(res => {
            this.catalogData = res
            this.getFirstContent(this.catalogData)
            this.expandedList.push(this.firstContentId)
            this.currentPage = {
                id: this.firstContentId
            }
            this.$nextTick(() => {
                this.$refs.catalogTree.setCurrentKey(this.firstContentId)
                this.getPageDetail()
            })
        }).catch(err => {
            console.info(err)
        })

    }
}
</script>

<style lang="scss">
.pc-view {
    background: rgb(248, 248, 248);
    height: 100%;
    overflow: hidden;
    
    .my-aside {
        padding: 16px 0;
        box-sizing: border-box;
        background: white;

        .el-tree-node__content {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            position: relative;
            height: 64px;
            line-height: 64px;
            margin-bottom: 16px;
            padding-right: 16px;
        }
    
        .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
            background-color: #eff2f7;
            box-sizing: border-box;
            color: #3b5998;
            border-radius: 8px;
        }
    
        .el-tree-node__content > .el-tree-node__expand-icon {
            font-size: 16px;
            position: absolute;
            right: 0;
        }
    
        .el-tree-node__expand-icon.is-leaf {
            cursor: default;
        }
    
        .el-tree-node[draggable='false'] > .el-tree-node__content:hover {
            background-color: transparent;
        }
    
        .el-tree-node.is-current[draggable='false'] > .el-tree-node__content:hover {
            background-color: #eff2f7;
        }
    
        .el-tree-node[draggable='false'] .el-tree-node__content:hover .el-dropdown,
        .el-tree-node.is-current[draggable='false'] > .el-tree-node__content .el-dropdown {
            display: inline-block !important;
        }
    
        .el-tree-node.is-drop-inner > .el-tree-node__content .overlength-text {
            background-color: #3B5998;
            color: white;
        }
    
        .el-tree-node[draggable='false']:focus > .el-tree-node__content {
            background-color: transparent;
        }
    
        .el-tree-node.is-current[draggable='false']:focus > .el-tree-node__content {
            background-color: #eff2f7;
        }
    }

    .content-title {
        line-height: 124px;
        font-size: 24px;
        text-align: center;
    }

}
</style>


// WEBPACK FOOTER //
// src/views/PcView.vue